import { Outlet, useOutletContext } from 'react-router-dom'

import CollectionsBootstrap from 'modules/finance/lib/QuotesCollectionsBootstrap'
import { SalesRootPageOutletContext } from 'modules/finance/pages/SalesRootPage'

const DealsRootPage = () => {
  const accumulatedContext = useOutletContext<SalesRootPageOutletContext>()

  return (
    <CollectionsBootstrap>
      <Outlet context={{ ...accumulatedContext }} />
    </CollectionsBootstrap>
  )
}

export default DealsRootPage
